var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgY(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "397px",
    height: "459px",
    viewBox: "0 0 397 459",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "y",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.832206,458.795637 L396.421073,0.572506339 C396.522733,0.383596768 396.452004,0.148043531 396.263094,0.0463834573 C396.206517,0.0159370269 396.143271,4.55628528e-14 396.079022,0 L285.503453,0 C285.357913,-1.23093465e-14 285.224583,0.0813596327 285.158022,0.21078764 L200.637308,164.56 L200.637308,164.56 L114.053323,0.20738726 C113.986129,0.0798414197 113.853824,5.88152599e-15 113.709661,0 L0.388434493,0 C0.173908046,-1.62592667e-15 6.45372644e-12,0.173908046 6.45372644e-12,0.388434493 C6.45372644e-12,0.454293537 0.0167453537,0.519071214 0.0486622944,0.576679569 L146.282022,264.52 L146.282022,264.52 L38.5800079,458.422954 C38.4758408,458.610493 38.5434269,458.846967 38.7309658,458.951135 C38.7886637,458.983182 38.8535761,459 38.919577,459 L149.490155,459 C149.633088,459 149.764473,458.921502 149.832206,458.795637 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgY);
export default __webpack_public_path__ + "static/media/y.67ad192a4705fdba28bc3aa145670d0c.svg";
export { ForwardRef as ReactComponent };